import React, {useState} from "react";
import { Box, Typography } from "@mui/material";
import DefaultLayout from "layout/defaultLayout";
import MetaTravelAdsIcon from "assets/images/IconMetaTravelAds.svg";
import "./SignUpMetaTravelAdsPage.scss";
import CustomButtonWithIconComponent from "components/CustomButtonWithIcon/Buttons";
import SignUpFormMetaTravelAds from "../../../features/product-sign-up/SignUpFormMetaTravelAds";

const SignUpMetaTravelAdsPage = () => {

  const [isPanelOpen, setPanelOpen] = useState(false);
  const togglePanel = () => {
    setPanelOpen((prev) => !prev);
  };

  return (
    <DefaultLayout page="Meta Hotel Ads">
      <Box className="metaTravelAdsSignUpPage">
        <div className="header-container">
          <div>
            <div className="header-left">
              <div className="icon-wrapper">
                <img src={MetaTravelAdsIcon} alt="Meta Hotel Ads" style={{ width: '40px', height: '40px' }} />
              </div>
              <div>
                <Typography className="quency-cf-normal heading">
                  Meta Hotel Ads
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className="summary-section">
          <Typography gutterBottom className="summary-title">
            SUMMARY
          </Typography>

          <Typography variant="body1" className="summary-text">
            <p className="summary-text-bold">
              Turn social inspiration into direct bookings
            </p>
            With 83% of travelers already turning to social media for
            inspiration and planning, visibility on Meta is a key driver in the
            guest journey. Activate targeted hotel ads across Facebook,
            Instagram, and Audience Network in just a few clicks. Powered by
            DMP's connectivity to 150+ market-leading providers, Cendyn uniquely
            empowers you to launch, scale, and optimize Meta Hotel Ads with
            ease.
            <p className="summary-text-bold">
              Ready to turn scrolling into bookings?
            </p>
            Gain a smarter, more connected way to drive demand on Meta, powered
            by real-time data and built for measurable performance.
          </Typography>

          <CustomButtonWithIconComponent
            onClick={togglePanel}
            color="#b0acac"
            hoverColor="#61D5A9"
            width="201px"
            height="44px"
            titleColor="#373F41"
            borderRadius="20px"
            title="Request a Demo"
            iconBorder="0.5px solid #373F41"
            textStyle={{
              display: "flex",
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "14.52px",
              textAlign: "center",
            }}
          >
            Request a Demo
          </CustomButtonWithIconComponent>
        </div>
      </Box>
      <SignUpFormMetaTravelAds isOpen={isPanelOpen} onClose={togglePanel} />
    </DefaultLayout>
  );
};

export default SignUpMetaTravelAdsPage;
